<template>
  <div>
    <!-- <v-tooltip bottom>
      <template v-slot:activator="{ on: tooltip }">
        <v-btn
          :disabled="closeDisabled"
          class="success mr-1"
          fab
          x-small
          v-on="{ ...tooltip }"
          @click="completeClose()"
        >
          <v-icon>mdi-check-all</v-icon>
        </v-btn>
      </template>
      <span>CLOSE CASE</span>
    </v-tooltip> -->

    <v-tooltip bottom>
      <template v-slot:activator="{ on: tooltip }">
        <v-hover v-slot="{ hover }">
          <v-btn
            block
            height="80"
            class="primary mr-1"
            :elevation="hover ? 8 : 2"
            v-on="{ ...tooltip }"
            :disabled="closeDisabled"
            @click="completeClose()"
          >
            <div class="d-flex flex-column align-center">
              <v-icon>mdi-check-all</v-icon>
              <span class="action-text">CLOSE CASE</span>
            </div>
          </v-btn>
        </v-hover>
      </template>
      <span>CLOSE CASE</span>
    </v-tooltip>

    <!-- THE DIALOG BEGINS HERE -->
    <v-dialog persistent v-model="dialogCompleteClose" max-width="750px">
      <v-card>
        <v-card-title class="justify-center text-h5 grey lighten-2">
          <span class="text-h5">CLOSE CASE</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-card width="100%" class="mt-3 mb-3 text-start">
                <v-card-title>Closing case</v-card-title>
                <!-- <v-list subheader two-line flat dense>
                  <v-subheader class="text-h6">I confirm:</v-subheader>

                  <v-list-item-group multiple>
                    <v-list-item>
                      <template v-slot:default="{ active }">
                        <v-list-item-action>
                          <v-checkbox
                            :input-value="active"
                            color="primary"
                            v-model="checkboxClose"
                          ></v-checkbox>
                        </v-list-item-action>

                        <v-list-item-content>
                          <v-list-item-title>Dispatch</v-list-item-title>
                          <v-list-item-subtitle
                            >Physical report along with attachments are not
                            required to be dispatched</v-list-item-subtitle
                          >
                        </v-list-item-content>
                      </template>
                    </v-list-item>
                  </v-list-item-group>
                </v-list> -->
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn
                    tile
                    dark
                    small
                    @click="closeDialog"
                    class="mt-3 mr-2 error"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    tile
                    :disabled="isFileButtonDisabled"
                    small
                    class="mt-3 success"
                    @click="compCloseSubmit"
                    >Submit</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CasefileDataService from "../../services/CasefileDataService";

import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "dispatch",
  props: ["management"],
  components: {},

  data() {
    return {
      // checkboxClose: false,
      dialogCompleteClose: false,
    };
  },

  computed: {
    closeDisabled() {
      return !(this.caseState.casefile.fileStatus == `DISP` && this.management);
    },

    ...mapState(["caseState"]),

    isFileButtonDisabled() {
      return !(
        // this.checkboxClose &&
        this.management
      );
    },
  },
  watch: {
    completeClose(val) {
      val || this.closeDialog();
    },
  },

  methods: {
    // moment: function (date) {
    //   return moment(date);
    // },

    completeClose() {
      this.dialogCompleteClose = true;
    },

    compCloseSubmit() {
      CasefileDataService.update(
        this.caseState.casefile.id,
        this.caseState.casefile,
        (this.caseState.casefile.fileStatus = `CLO`),
        (this.caseState.casefile.dateClosed = moment().format()),
        (this.caseState.casefile.closedBy = this.$store.state.auth.user.id)
      )
        // (this.caseState.casefile.dateOfReg = moment().format())

        .then((response) => {
          this.closeDialog();
          this.$store.dispatch("setSnackbar", {
            showing: true,
            color: "warning",
            text:
              (response && response.data && response.data.message) ||
              toString(),
          });
        })
        .catch((e) => {
          console.log(e);
        });

      this.closeDialog();
    },

    closeDialog() {
      this.dialogCompleteClose = false;
      this.$nextTick(() => {
        // this.caseState.casefile.fileStatus = "ADAC";
      });
    },
  },
};
</script>
